export default __webpack_public_path__ + "static/media/LogoImage.dd052b77.svg";